import axios from "axios";

var getMeetings = function getMeetings(groupId) {
  return axios.get("/groups/" + groupId + "/future-meetings");
};

var getPreviousMeetings = function getPreviousMeetings(groupId, nextPage) {
  return axios.get("/groups/".concat(groupId, "/previous-meetings?page=").concat(nextPage));
};

var getSingleMeetingForCollection = function getSingleMeetingForCollection(groupId, meetingId) {
  return axios.get("/groups/".concat(groupId, "/meetings/").concat(meetingId, "/single-for-collection"));
};

var storeMeeting = function storeMeeting(groupId, request) {
  return axios.post("/groups/" + groupId + "/meetings", request);
};

var updateTheMeeting = function updateTheMeeting(groupId, meetingId, request) {
  return axios.put("/groups/" + groupId + "/meetings/" + meetingId, request);
};

var archiveMeeting = function archiveMeeting(groupId, meetingId, request) {
  return axios.put("/groups/".concat(groupId, "/meetings/").concat(meetingId, "/archive"), request);
};

var destroyMeeting = function destroyMeeting(groupId, meetingId) {
  return axios.delete("/groups/" + groupId + "/meetings/" + meetingId);
};

export { getMeetings, getPreviousMeetings, storeMeeting, updateTheMeeting, destroyMeeting, archiveMeeting, getSingleMeetingForCollection };